module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p_background"
  }, [_c('div', {
    staticClass: "container_right_info"
  }, [_c('div', {
    staticClass: "clearfix tb_padding"
  }, [_c('div', {
    staticClass: "container_box"
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "partition_message developer_box publick_form_box developer_basic_box"
  }, [_c('section', {
    staticClass: "form_box"
  }, [_c('label', {
    staticClass: "form_label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("手机号码：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.tCloudUser.mobile))])]), _vm._v(" "), _c('section', {
    staticClass: "form_box"
  }, [_c('label', {
    staticClass: "form_label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("企业名称：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.tCloudUserCompany.companyName))])]), _vm._v(" "), _c('section', {
    staticClass: "form_box"
  }, [_c('label', {
    staticClass: "form_label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("统一社会信用代码：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.tCloudUserCompany.companyNo))])]), _vm._v(" "), _c('section', {
    staticClass: "form_box"
  }, [_c('label', {
    staticClass: "form_label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("联系地址：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.tCloudUserCompany.sites))])]), _vm._v(" "), _c('section', {
    staticClass: "form_box"
  }, [_c('label', {
    staticClass: "form_label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("营业执照：")]), _vm._v(" "), _c('div', {
    staticClass: "example id_card_photo inline-block",
    attrs: {
      "id": "images"
    }
  }, [_c('img', {
    staticClass: "zoomify img_default",
    attrs: {
      "src": _vm.echoImg,
      "alt": "",
      "title": "营业执照",
      "id": "imgz",
      "width": "234px"
    }
  })])]), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('div', {
    staticClass: "container_box"
  }, [_vm._m(2), _vm._v(" "), _c('section', {
    staticClass: "partition_message developer_box publick_form_box developer_basic_box"
  }, [_c('section', {
    staticClass: "form_box"
  }, [_c('label', {
    staticClass: "form_label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("开户行：")]), _vm._v(" "), (_vm.tCloudUserBankcard != null) ? _c('span', [_vm._v(_vm._s(_vm.tCloudUserBankcard.bankType))]) : _vm._e()]), _vm._v(" "), _c('section', {
    staticClass: "form_box"
  }, [_c('label', {
    staticClass: "form_label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("开户支行：")]), _vm._v(" "), (_vm.tCloudUserBankcard != null) ? _c('span', [_vm._v(_vm._s(_vm.tCloudUserBankcard.bankBranch))]) : _vm._e()]), _vm._v(" "), _c('section', {
    staticClass: "form_box"
  }, [_c('label', {
    staticClass: "form_label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("银行卡号：")]), _vm._v(" "), (_vm.tCloudUserBankcard != null) ? _c('span', [_vm._v(_vm._s(_vm.tCloudUserBankcard.cardNo))]) : _vm._e()]), _vm._v(" "), _c('section', {
    staticClass: "form_box"
  }, [_c('label', {
    staticClass: "form_label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("开户名：")]), _vm._v(" "), (_vm.tCloudUserBankcard != null) ? _c('span', [_vm._v(_vm._s(_vm.tCloudUserBankcard.cardUsername))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "container_box"
  }, [_vm._m(3), _vm._v(" "), _c('section', {
    staticClass: "partition_message developer_box publick_form_box developer_basic_box"
  }, [_c('section', {
    staticClass: "form_box"
  }, [_c('label', {
    staticClass: "form_label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("联系地址：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.tCloudUserCompany.sites))])]), _vm._v(" "), _c('section', {
    staticClass: "form_box"
  }, [_c('label', {
    staticClass: "form_label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("联系人姓名：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.tCloudUserCompany.companyContacts))])]), _vm._v(" "), _c('section', {
    staticClass: "form_box"
  }, [_c('label', {
    staticClass: "form_label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("电子邮箱：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.tCloudUser.email))])]), _vm._v(" "), _c('section', {
    staticClass: "form_box"
  }, [_c('label', {
    staticClass: "form_label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("手机号码：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.tCloudUser.mobile))])]), _vm._v(" "), _c('section', {
    staticClass: "form_box"
  }, [_c('label', {
    staticClass: "form_label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("其它电话：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.tCloudUserCompany.companyPhone))])]), _vm._v(" "), _c('section', {
    staticClass: "form_box"
  }, [_c('label', {
    staticClass: "form_label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("QQ：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.tCloudUser.qq))])]), _vm._v(" "), _c('section', {
    staticClass: "form_box"
  }, [_c('label', {
    staticClass: "form_label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("官网地址：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.tCloudUserCompany.companyUrl))])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "message_title"
  }, [_c('span', [_vm._v("基本信息")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "form_box"
  }, [_c('label', {
    staticClass: "form_label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("认证情况：")]), _vm._v(" "), _c('span', [_vm._v("【已认证】")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "message_title"
  }, [_c('span', [_vm._v("结算方式")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "message_title"
  }, [_c('span', [_vm._v("联系方式")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-0c054275"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/company_data.vue
// module id = 1235
// module chunks = 1